import { GeneralTreatingPhysicianFieldController } from "./general-treating-physician-field-controller";

export class TreatingPhysicianLastNameFieldController extends GeneralTreatingPhysicianFieldController {}
